import { jsx as _jsx } from "react/jsx-runtime";
import { CatUtilityNav } from '@blocks-react/components/UtilityNav';
export const SubheaderUtilityNav = ({ children }) => {
    return _jsx(CatUtilityNav, { "data-testId": "subheader-utility-nav", children: children });
};
